import {
  apiAddOrderToCart,
  apiGetCartDetails,
  apiRemoveCartItem,
  apiCartCheckout,
} from 'api/cart';
import cartTypes from '../types/cart';

export const addOrderToCart = (companyId, data, cb) => ({
  isAsyncCall: true,
  baseType: cartTypes.ADD_ORDER_TO_CART,
  payload: {},
  asyncCall: () => apiAddOrderToCart(companyId, data),
  afterSuccessCall: (_dispatch, response) => {
    if (cb) cb(response);
  },
  afterFailureCall: (_dispatch, err) => {
    if (cb) cb(false, err);
  },
});

export const getCartDetails = (companyId, cartId, cb) => ({
  isAsyncCall: true,
  baseType: cartTypes.GET_CART_DETAILS,
  payload: {},
  asyncCall: () => apiGetCartDetails(companyId, cartId),
  afterSuccessCall: (_dispatch, response) => {
    if (cb) cb(response);
  },
  afterFailureCall: (_dispatch, err) => {
    if (cb) cb(false, err);
  },
});

export const removeCartItem = (companyId, itemId, cb) => ({
  isAsyncCall: true,
  baseType: cartTypes.REMOVE_CART_ITEM,
  payload: {},
  asyncCall: () => apiRemoveCartItem(companyId, itemId),
  afterSuccessCall: (_dispatch, response) => {
    if (cb) cb(response);
  },
  afterFailureCall: (_dispatch, err) => {
    if (cb) cb(false, err);
  },
});

export const cartCheckout = (companyId, data, cb) => ({
  isAsyncCall: true,
  baseType: cartTypes.CART_CHECKOUT,
  payload: {},
  asyncCall: () => apiCartCheckout(companyId, data),
  afterSuccessCall: (_dispatch, response) => {
    if (cb) cb(response);
  },
  afterFailureCall: (_dispatch, err) => {
    if (cb) cb(false, err);
  },
});
